import { render, staticRenderFns } from "./ApprovalDescriptionField.vue?vue&type=template&id=0d95421e&scoped=true"
import script from "./ApprovalDescriptionField.vue?vue&type=script&lang=js"
export * from "./ApprovalDescriptionField.vue?vue&type=script&lang=js"
import style0 from "./ApprovalDescriptionField.vue?vue&type=style&index=0&id=0d95421e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d95421e",
  null
  
)

export default component.exports